import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';
import type { AxiosProgressEvent } from 'axios';

export const CampaignsService = {
  getHeaders: (data: FormData, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}campaigns/csv/headers`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress
    });
  },
  saveCampaigns: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}campaigns`, data);
  },
  getMaskOuputs: (account: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}masks/sms/account/${account}`);
  },
  getAccountsOuputs: (account: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/whatsapp/account/${account}`);
  },
  getAgentsOuputs: (account: string, type: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}agents/rcs/account/${account}/type/${type}`);
  },
  saveMessageTest: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}campaigns/message/test`, data);
  }
};
